import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    name: 'Index',
    component: Index,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/index')
      }
    ]
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/views/policy')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
